import React from 'react'
import { useIntl } from 'react-intl'

import { HouseCorporateEveningIndividualFieldProps } from '../form-container/HouseCorporateEveningIndividualFormContainer'
import { ControlledSwitchField } from '../../../../../../../forms'

export const HouseCorporateEveningIndividualIsEnabledField = ({
  control,
  isFieldDisabled,
}: Omit<HouseCorporateEveningIndividualFieldProps, 'currencyArea'>) => {
  const intl = useIntl()
  return (
    <ControlledSwitchField
      control={control}
      name='isEnabled'
      label={intl.formatMessage({
        defaultMessage: "Acceptez-vous les soirées d'entreprise ?",
        id: 'ui.HouseCorporateEveningIndividualIsEnabledField.label',
      })}
      inline={true}
      disabled={isFieldDisabled}
    />
  )
}
